module.exports = __webpack_public_path__ + "static/media/camion.f2edbc51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rrhh/camion.png
// module id = 1105
// module chunks = 0